import { BNButton, BNStack } from "@bn-monorepo/js-packages";
import { ArticleSettings } from "../../SectionPage";
import SectionWrapperText from "../Section/SectionWrapperText";
import SectionWrapper from "../Section/SectionWrapper";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { SettingsContext } from "../../../../../settingsContext";
import { ExpandMore } from "@mui/icons-material";

interface Props {
  tableOfContents?: ArticleSettings["tableOfContents"];
}

export const TableOfContents: React.FC<Props> = ({ tableOfContents }) => {
  const { localization } = useContext(SettingsContext);
  if (!tableOfContents?.length) {
    return;
  }
  const [isJs, setIsJs] = useState(false);
  useEffect(() => setIsJs(true), []);
  return (
    <SectionWrapper
      anchorId={"table-of-contents"}
      backgroundColor={"transparent"}
      noImage={true}
      sx={{ my: "0rem !important", mt: 2, textAlign: "left" }}
    >
      <SectionWrapperText
        sxTextSectionContainer={{
          py: "0rem !important",
        }}
      >
        <Accordion
          //Must be div when isJs since else Enter doesn't work
          component={isJs ? "div" : "details"}
          slotProps={{ heading: { component: "summary", tabIndex: -1 } }}
          sx={{
            textAlign: "left",
            ".MuiAccordionSummary-root:focus": {
              backgroundColor: "rgba(0,0,0,0.12)",
            },
            "&::before": {
              height: 0,
            },
            "&[open]": {
              ".MuiCollapse-root": {
                height: "auto",
                visibility: "visible",
              },
              ".MuiAccordionSummary-expandIconWrapper": {
                transform: "rotate(180deg)",
              },
            },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore color="primary" />}
            aria-controls={`toc-content`}
            id={"toc"}
            slotProps={{ root: { component: "div" } }}
          >
            <Typography variant="h6" component={"h2"} sx={{ fontWeight: "bold" }}>
              {localization.tableOfContents_heading}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {tableOfContents?.map((x, i) => (
              <BNStack
                key={`toc-item-${i}`}
                direction={"row"}
                sx={{
                  alignItems: "baseline",
                  gap: 0.5,
                }}
              >
                <BNButton href={`#${encodeURIComponent(x)}`} variant="text" sx={{ px: 0 }}>
                  {i + 1}: {x}
                </BNButton>
              </BNStack>
            ))}
          </AccordionDetails>
        </Accordion>
      </SectionWrapperText>
    </SectionWrapper>
  );
};
